module.exports = "<button\n  class=\"sidebar-minimizer\"\n  type=\"button\"\n  appSidebarMinimizer\n  appBrandMinimizer\n></button>\n"